<template>
  <div class="container f-rte">
    <ControlGroup>
      <h4 class="comparison_title">
        Comparing {{ parameterValues["Indicator"] }} with
        {{ indicatorToCompare }}
      </h4>
      <DataExplorerParam
        class="control-group--item"
        name="View type"
        type="buttonGroup"
        v-model="viewType"
        :options="[
          { label: 'Sector', value: 'Technology or Sector' },
          { label: 'Country', value: 'Country' },
        ]"
      />
    </ControlGroup>
    <DataExplorer :indicators="indicators" />
  </div>
</template>
<script>
import { categoryIndicators } from "./data/data";

import { ControlGroup } from "@international-energy-agency/vue-ui";
import {
  DataExplorerParam,
  DataExplorer,
} from "@international-energy-agency/vue-ui/highcharts";

export default {
  name: "IndicatorComparison",
  components: {
    ControlGroup,
    DataExplorerParam,
    DataExplorer,
  },
  props: {
    parameterValues: {
      type: Object,
      required: true,
    },
    apiRoute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      categoryIndicators,
      viewType: "Technology or Sector",
    };
  },
  computed: {
    indicatorToCompare() {
      if (/conditional on skills/i.test(this.parameterValues["Indicator"])) {
        return this.parameterValues["Indicator"].replace(
          / conditional on skills/,
          ""
        );
      } else {
        return this.parameterValues["Indicator"].replace(
          /wage gap/,
          "wage gap conditional on skills"
        );
      }
    },
    hasCategories() {
      return /by/.test(this.parameterValues["Indicator"]);
    },
    indicators() {
      const { apiRoute } = this;
      const indicators = [];
      if (this.viewType === "Technology or Sector") {
        for (let sector of this.parameterValues["Technology or Sector"]) {
          indicators.push({
            url: apiRoute,
            type: "small-multiples",
            staticParams: {
              "Technology or Sector": sector,
              Country: this.parameterValues["Country"],
              Indicator: [
                this.parameterValues["Indicator"],
                this.indicatorToCompare,
              ],
              "Number of observations": this.parameterValues[
                "Number of observations"
              ],
              latest: this.hasCategories,
            },
            config: {
              title: `Comparison between indicators for sector: ${sector}`,
              chartType: this.hasCategories ? "column" : "line",
              xAxisDimension: this.hasCategories
                ? "Indicator Categories"
                : "Year",
              yAxisDimension: "Indicator",
              groupDimension: "Country",
              valueDimension: "Value",
              chartOptions: {
                yAxis: {
                  reversedStacks: true,
                  visible: this.hasCategories,
                },
                plotOptions: {
                  column: {
                    stacking: undefined,
                  },
                },
              },
            },
          });
        }
      } else if (this.viewType === "Country") {
        for (let country of this.parameterValues["Country"]) {
          indicators.push({
            url: apiRoute,
            type: "small-multiples",
            staticParams: {
              "Technology or Sector": this.parameterValues[
                "Technology or Sector"
              ],
              Country: country,
              Indicator: [
                this.parameterValues["Indicator"],
                this.indicatorToCompare,
              ],
              "Number of observations": this.parameterValues[
                "Number of observations"
              ],
              latest: this.hasCategories,
            },
            config: {
              title: `Comparison between indicators for country: ${country}`,
              chartType: this.hasCategories ? "column" : "line",
              xAxisDimension: this.hasCategories
                ? "Indicator Categories"
                : "Year",
              yAxisDimension: "Indicator",
              groupDimension: "Technology or Sector",
              valueDimension: "Value",
              chartOptions: {
                yAxis: {
                  reversedStacks: true,
                  visible: this.hasCategories,
                },
                plotOptions: {
                  column: {
                    stacking: undefined,
                  },
                },
              },
            },
          });
        }
      }

      return indicators;
    },
  },
};
</script>
<style scoped>
.comparison_title {
  font-size: 1rem;
  position: relative;
  margin: 0;
  /* padding: 16px 20px; */
  width: 75% !important;
}
</style>